import { Icon, PlusMinus } from '@tallink/components-lib'
import classNames from 'classnames'
import React from 'react'

import MorePropTypes from '../../../utils/MorePropTypes'
import Hint from '../Hint/Hint'
import s from './DesktopSerialTicket.module.scss'

export default function DesktopSerialTicket({ ticket, plusMinusProps }) {
  const { code, name, price, type, title, description } = ticket
  const iconProps = getIconProps({ type, code })

  return (
    <div id={code}>
      <div className={s.cell}>
        <div className={s['round-icon']}>{iconProps && <Icon {...iconProps} />}</div>
      </div>
      <div className={classNames(s.cell, s['text-and-price'])}>
        <div className={s.text}>
          <span className={s.name} dangerouslySetInnerHTML={{ __html: name }} />
          {(title || description) && <Hint text={description} title={title} />}
        </div>
        <div className={s.price}>{price} €</div>
      </div>
      <div className={classNames(s.cell, s.amount)}>
        <PlusMinus {...plusMinusProps} />
      </div>
    </div>
  )
}

DesktopSerialTicket.propTypes = {
  plusMinusProps: MorePropTypes.plusMinusDesktopProps.isRequired,
  ticket: MorePropTypes.serialTicket.isRequired
}

export function getIconProps({ type, code }) {
  if (type === 'PASSENGER') return { type: 'adult', size: 'l' }
  if (type === 'VEHICLE') {
    const vehicleType = code?.startsWith('SERIAL V') ? 'vehicle-van' : 'vehicle-car'

    return { type: vehicleType, size: 'xl' }
  }
  return null
}
